import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Popover } from "antd";
/**
 * Custom All-In-One Tree tooltip implementation with the help of ant-design.
 */ const Tooltip = ({ placement = "bottom", children, title, content, mouseEnterDelay = 0.2, mouseLeaveDelay = 0, ...rest })=>{
    const popoverContent = /*#__PURE__*/ _jsxs("div", {
        style: {
            fontSize: 12,
            maxWidth: 200
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: {
                    fontWeight: "bold",
                    fontSize: 14,
                    paddingBottom: 5,
                    marginBottom: 3,
                    borderBottom: "1px solid rgba(255,255,255,0.3)"
                },
                children: title
            }),
            content
        ]
    });
    return /*#__PURE__*/ _jsx(Popover, {
        content: popoverContent,
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        ...rest,
        children: children
    });
};
export { Tooltip };
